import * as React from 'react';
import get from 'lodash/get';

import { ProlongationPopupModal } from './ProlongationPopupModal';
import { IPopupLinkData } from '../../../shared/types/moderation';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IProlongationPopupProps {
  /** Данные для попапа */
  popupData: IPopupLinkData | null;
}

export interface IProlongationPopupState {
  /** Видимость попапа */
  isOpen: boolean;
  /** Если объявлений больше одного */
  hasMultiple: boolean;
}

export class ProlongationPopup extends React.Component<IProlongationPopupProps, IProlongationPopupState> {
  public state: IProlongationPopupState = {
    isOpen: false,
    hasMultiple: false,
  };

  public async componentDidMount() {
    const { popupData } = this.props;

    if (popupData && popupData.popupType === 'prolongation') {
      this.setState({ isOpen: true, hasMultiple: popupData.itemsCount > 1 });
    }
  }

  private handleClosePopup = () => this.setState({ isOpen: false });

  public render() {
    const { popupData } = this.props;
    const { isOpen, hasMultiple } = this.state;

    const address = (popupData && popupData.address) || '';
    const announcementUrl = (popupData && popupData.announcementUrl) || '';
    const operationType = (popupData && popupData.operationType) || '';
    const realtyObjectId: number = get(popupData, 'items.0.realtyObjectId', 0);

    return (
      <ProlongationPopupModal
        address={address}
        announcementUrl={announcementUrl}
        isOpen={isOpen}
        hasMultiple={hasMultiple}
        realtyObjectId={realtyObjectId}
        operationType={operationType}
        onClose={this.handleClosePopup}
      />
    );
  }
}
